import { useEffect } from "react";

export default function useLoadScripts(scripts) {
  useEffect(() => {
    const loadedScripts = [];

    const loadScript = (src) => {
      return new Promise((resolve) => {
        const existing = document.querySelector(`script[src="${src}"]`);
        if (existing) existing.remove();

        const script = document.createElement("script");
        script.src = src;
        script.async = false;
        script.onload = resolve;
        script.onerror = resolve;
        document.body.appendChild(script);
        loadedScripts.push(script);
      });
    };

    const loadAll = async () => {
      for (const src of scripts) {
        await loadScript(src);
      }
      console.log("✅ All scripts loaded!");
    };

    // ✅ Thoda wait karo — DOM properly render ho jaye
    const timer = setTimeout(() => {
      loadAll();
    }, 300);

    return () => {
      clearTimeout(timer);
      loadedScripts.forEach((script) => {
        if (document.body.contains(script)) {
          document.body.removeChild(script);
        }
      });
    };
  }, []);
}